// @ts-nocheck
import React from "react";
import Select, { SelectChevron } from "./ReusableComponents/Select";

// The forecast picker, shared by the asset graph, the datasets page, the date picker and the asset dashboard cards. It stays a dropdown — the schema can carry a dozen forecasts, which a segmented control could not hold — with the toolbar pill as its trigger on the shared Select, so a phone gets the same centered card as every other picker.
// Hand it `selectedForecasts` and `onSelectionChange` and it becomes a multi-select: checkboxes on desktop, tap-to-toggle rows on a phone, and one forecast always stays selected. With `onReorder` every row also gets a grip to drag it into a new place; the host keeps that order and hands it back as `forecastOrder`.
const ForecastSelect = ({
  activeForecast,
  foreCastSchema,
  onForecastSelect,
  selectedForecasts,
  onSelectionChange,
  onReorder,
  forecastOrder,
}) => {
  const multiple = Array.isArray(selectedForecasts) && typeof onSelectionChange === "function";
  const active = foreCastSchema?.[activeForecast];
  const ActiveIcon = active?.Icon;
  const options = Object.entries(foreCastSchema || {})
    .filter(([, forecast]) => forecast)
    .map(([key, { Icon, name }]) => ({
      value: key,
      label: name,
      icon: Icon ? <Icon className="h-4 w-4 [&_path]:stroke-current" /> : undefined,
    }));

  // The picker's own order, when the host keeps one; stacked charts follow it
  const orderedOptions = forecastOrder?.length
    ? [
        ...forecastOrder.map((key) => options.find((o) => o.value === key)).filter(Boolean),
        ...options.filter((o) => !forecastOrder.includes(o.value)),
      ]
    : options;

  if (multiple) {
    const extra = selectedForecasts.length - 1;
    const triggerLabel = `${active?.name || "Select forecast"}${extra > 0 ? ` +${extra}` : ""}`;
    return (
      <Select
        multiple
        aria-label="Select forecasts"
        title={selectedForecasts.map((key) => foreCastSchema?.[key]?.name).filter(Boolean).join(", ") || "Select forecasts"}
        className="eai-btn-toolbar w-full min-w-0 justify-between sm:w-auto sm:min-w-[11rem] sm:max-w-[18rem]"
        containerClassName="min-w-0 sm:w-auto"
        trigger={
          <>
            {ActiveIcon && extra === 0 && <ActiveIcon className="h-4 w-4 shrink-0 [&_path]:stroke-current" />}
            <span className="truncate">{triggerLabel}</span>
            <SelectChevron className="h-3 w-3" />
          </>
        }
        value={selectedForecasts}
        onChange={(e) => {
          const next = Array.from(e.target.selectedOptions).map((o) => o.value);
          // At least one stays picked — clearing the last one is ignored
          if (next.length > 0) onSelectionChange(next);
        }}
        options={orderedOptions}
        onReorder={onReorder}
        // Each row carries a checkbox, an icon and a drag grip beside the name, so the list needs more room than the pill
        listMinWidth={288}
      />
    );
  }

  return (
    <Select
      aria-label="Select forecast"
      title={active?.name || "Select forecast"}
      className="eai-btn-toolbar w-full min-w-0 justify-between sm:w-auto sm:min-w-[10rem] sm:max-w-[14rem]"
      containerClassName="min-w-0 sm:w-auto"
      trigger={
        <>
          {ActiveIcon && <ActiveIcon className="h-4 w-4 shrink-0 [&_path]:stroke-current" />}
          <span className="truncate">{active?.name || "Select forecast"}</span>
          <SelectChevron className="h-3 w-3" />
        </>
      }
      value={activeForecast ?? ""}
      onChange={(e) => e.target.value !== activeForecast && onForecastSelect(e.target.value)}
      options={options}
    />
  );
};

export default ForecastSelect;
